import { c as _c } from "react/compiler-runtime";
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { DatePicker } from '@shared/ui-components/date-picker/date-picker';
import styles from '@module/mdrt-org/dashboard/dashboard-page-content/components/pdf-modal-wrapper/press-release-pdf-modal/press-release-pdf-modal.module.scss';
type AnnouncementDateSectionProps = {
  cmsContent: {
    announcementDateDescription: string;
    announcementDateHeading: string;
    requiredLabel: string;
  };
  containerClass: string;
  setActiveField: (field: string) => void;
};
export const AnnouncementDateSection = t0 => {
  const $ = _c(24);
  const {
    cmsContent,
    containerClass,
    setActiveField
  } = t0;
  const t1 = styles[`${containerClass}__date-block`];
  const t2 = styles[`${containerClass}__date-block-title`];
  let t3;
  if ($[0] !== cmsContent.announcementDateHeading) {
    t3 = <h2 className={styles["section-title"]}>{cmsContent.announcementDateHeading}</h2>;
    $[0] = cmsContent.announcementDateHeading;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== cmsContent.announcementDateDescription) {
    t4 = <p className={styles["section-description"]}>{cmsContent.announcementDateDescription}</p>;
    $[2] = cmsContent.announcementDateDescription;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== cmsContent.requiredLabel) {
    t6 = {
      required: cmsContent.requiredLabel
    };
    $[8] = cmsContent.requiredLabel;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = styles[`${containerClass}__date-picker`];
  let t8;
  if ($[10] !== setActiveField) {
    t8 = () => setActiveField("Date");
    $[10] = setActiveField;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== cmsContent.announcementDateHeading || $[13] !== t7 || $[14] !== t8) {
    t9 = <DatePicker ariaLabel={cmsContent.announcementDateHeading} className={t7} onFocus={t8} />;
    $[12] = cmsContent.announcementDateHeading;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== cmsContent.announcementDateHeading || $[17] !== t6 || $[18] !== t9) {
    t10 = <FieldController displayErrorIcon={false} displayLabel={false} label={cmsContent.announcementDateHeading} name="date" rules={t6}>{t9}</FieldController>;
    $[16] = cmsContent.announcementDateHeading;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t1 || $[21] !== t10 || $[22] !== t5) {
    t11 = <section className={t1}>{t5}{t10}</section>;
    $[20] = t1;
    $[21] = t10;
    $[22] = t5;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};